import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { API_URL } from "utils/ApiUrl";
import { useWeb3React } from "@web3-react/core";
import useAuth from "./useAuth";

const useFetchUserData = () => {
  const { account } = useWeb3React();
  console.log(account, "acccoumttttt");

  const { logout } = useAuth();

  const history = useHistory();

  const [userData, setUserData] = useState();

  const handleLogOut = async () => {
    if (account) {
      const connectorId = window.localStorage.getItem("connectorId");
      await logout(connectorId);
      localStorage.removeItem("connectorId");
      localStorage.removeItem("flag");
    }
    localStorage.clear();
    history.push("/login");
  };

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");

    // If no access token, redirect to login
    if (!accessToken) {
      handleLogOut();
      return;
    }

    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_URL}/users/profile`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });

        setUserData(response);
        console.log(response);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          // Unauthorized: Session expired or invalid token
          toast.error("Session expired. Please log in again.");
          handleLogOut();
        } else {
          // Handle other errors
          console.log("Session expired. Please log in again.");

          toast.error("Something went wrong. Please try again later.");
        }
      }
    };

    fetchData();
  }, [history]); // Re-run if history changes (e.g., user logs out)
  //   console.log(userData);
  return userData;
};

export default useFetchUserData;
